import { FC, useMemo } from 'react';

import AvailableIcon from './IconsSvg/AvailableIcon';
import NotAvailableIcon from './IconsSvg/NotAvailableIcon';

import { getRequestedLanguages } from '../locale/languages';
import { AVAILABLE_STATUS } from '../utils/enum/AvailableStatus';

interface Props {
    status: AVAILABLE_STATUS;
}

const AvailableStatusComponent: FC<Props> = ({ status }) => {
    const language = getRequestedLanguages(window.berardi_accountUserData.language);

    const classStatus = useMemo(() => {
        switch (status) {
            case AVAILABLE_STATUS.Available:
                return 'available';
            case AVAILABLE_STATUS.InsufficientQty:
                return 'insufficient';
            case AVAILABLE_STATUS.NotAvailable:
                return 'notAvailable';
            default:
                return 'available';
        }
    }, [status]);

    const labelStatus = useMemo(() => {
        switch (status) {
            case AVAILABLE_STATUS.Available:
                return language.product.clothing_selector.available;
            case AVAILABLE_STATUS.InsufficientQty:
                return language.product.clothing_selector.insufficient_qty;
            case AVAILABLE_STATUS.NotAvailable:
                return language.product.clothing_selector.not_available;
            default:
                return language.product.clothing_selector.available;
        }
    }, [status]);

    const iconStatus = useMemo(() => {
        switch (status) {
            case AVAILABLE_STATUS.Available:
                return <AvailableIcon />;
            case AVAILABLE_STATUS.InsufficientQty:
                return <AvailableIcon color="#F28F1C" />;
            case AVAILABLE_STATUS.NotAvailable:
                return <NotAvailableIcon />;
            default:
                return language.product.clothing_selector.available;
        }
    }, [status]);

    return (
        <div className={`br-availableStatus ${classStatus}`}>
            {iconStatus}
            <span className="label">{labelStatus}</span>
        </div>
    );
};

export default AvailableStatusComponent;
